import client from '@/graphql/client'
import CreateProject from '@/graphql/mutations/CreateProject'
import UpdateProject from '@/graphql/mutations/UpdateProject'
import DeleteProject from '@/graphql/mutations/DeleteProject'

export const project = {
  namespaced: true,
  actions: {
    async createProject ({ commit }, { organisationId, name }) {
      try {
        const { createProject } = await client.query({
          operationName: 'createProject',
          query: CreateProject,
          variables: {
            name,
            organisationId
          }
        })
        commit('projectMemberships/addProjectMembership', createProject.createAdminTeamMember, { root: true })
        commit('snackbar/showMessage', { content: 'Created' }, { root: true })
        return createProject.createProjectFunction.id
      } catch (e) {
        console.log(e)
      }
    },

    async updateProject ({ commit, state, rootState }, item) {
      try {
        const res = await client.query({
          operationName: 'updateProject',
          query: UpdateProject,
          variables: {
            id: item.id,
            organisationId: item.organisationId,
            name: item.name
          }
        })
        commit('projectMemberships/updateProject', res.updateProject, { root: true })
        commit('snackbar/showMessage', { content: 'Updated' }, { root: true })
        return res.updateProject.id
      } catch (e) {
        console.log(e)
      }
    },

    async deleteProject ({ commit }, { id }) {
      try {
        const { deleteProject } = await client.query({
          operationName: 'deleteProject',
          query: DeleteProject,
          variables: { id }
        })
        commit('projectMemberships/deleteProjectMembership', { projectId: deleteProject.id }, { root: true })
        commit('snackbar/showMessage', { content: 'Deleted' }, { root: true })
      } catch (e) {
        console.log(e)
      }
    }
  }
}
